import { VerbatimField } from '@/configuration/VerbatimField';

export const verbatims = {
  [VerbatimField.Bhv_Improvement_RoleModel]: {
    title(isSelfSurvey, params) {
      return `Thinking about these five behaviors, which do you think ${
        isSelfSurvey
          ? 'you role model'
          : `<span class="primary--text">${params.EvaluateeFullName}</span> role models`
      } and how?`;
    },
  },
  [VerbatimField.Bhv_Improvement_SeeMore]: {
    title(isSelfSurvey, params) {
      return `What about development areas? Can ${
        isSelfSurvey
          ? 'you make any improvements?'
          : `<span class="primary--text">${params.EvaluateeFullName}</span> make any improvements in your opinion?`
      }`;
    },
  },
  [VerbatimField.Improvement_Strength]: {
    title(isSelfSurvey, params) {
      return `Thinking about these inclusive leadership traits, please provide examples that demonstrate ${
        isSelfSurvey
          ? 'your'
          : `<span class="primary--text">${params.EvaluateeFullName}'s</span>`
      } strengths in action.`;
    },
  },
  [VerbatimField.Improvement_Development]: {
    title(isSelfSurvey, params) {
      return `What about development areas? Can ${
        isSelfSurvey
          ? 'you make any improvements'
          : `<span class="primary--text">${params.EvaluateeFullName}</span> make any improvements in your opinion`
      }?`;
    },
  },
};
